import api from "./client";

export async function fetchGatewayStatusOverview() {
  const { data } = await api.get("/gateway-status/overview");
  return data || { totals: {}, sites: [] };
}

export async function fetchGatewayStatusBatches(siteId, limit = 50, offset = 0) {
  if (!siteId) return { batches: [] };
  const { data } = await api.get(`/gateway-status/site/${siteId}/batches`, {
    params: { limit, offset },
  });
  return data || { batches: [] };
}

export async function fetchGatewayStatusDaily(siteId, days = 30) {
  if (!siteId) return { days: [] };
  const { data } = await api.get(`/gateway-status/site/${siteId}/daily`, {
    params: { days },
  });
  return data || { days: [] };
}
